module.exports = __webpack_public_path__ + "static/Marigold Health-fd1819066d5faf5abc6fff89319e3ff7.jpg";